// src/pages/Login.js
import { React, useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import instance from '../api/axiosConfig';
import JWTService from '../services/JWTService';
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { ToastContainer, Bounce, toast } from 'react-toastify';

const clientId = "688623649092-l4plb79fp4eiq0ql5s9si3f0fgrrvs7u.apps.googleusercontent.com";

const Login = () => {
  const navigate = useNavigate();

  const { user, loginUser } = useUser(); // Use context

  useEffect(() => {
    if (user && !JWTService.isTokenExpired(user.token)) navigate("/app");

  })

  const onSuccess = async (response) => {
    try {
      const responseData = await instance.post("/auth/google", {
        clientId: response.clientId,
        credential: response.credential,
      });

      loginUser(responseData.data);

      toast.success('🦄 Welcome !' + responseData.data.name, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      navigate("/app");

      // Lưu thông tin user hoặc JWT từ backend (nếu có)
    } catch (error) {
      console.error("Error sending token to backend:", error);
    }

  };

  const onFailure = (response) => {
    console.log('Login Failed:', response);
  };

  return (
    <div className="container mx-auto max-w-md p-6">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-gray-100 rounded-xl mx-auto mb-4 flex items-center justify-center">
          <span className="text-2xl">🏃</span>
        </div>
        <h1 className="text-2xl font-bold mb-2">Welcome back!</h1>
      </div>

      <div className="mb-4">
        <GoogleOAuthProvider clientId={clientId}>
          <GoogleLogin onSuccess={onSuccess} onError={onFailure} text='signin_with' />

        </GoogleOAuthProvider>
      </div>


      <div className="space-y-4 mb-6">
        <div>
          <label className="block text-gray-600 mb-2">Email</label>
          <input type="email" placeholder="luke@skywalker.com" className="w-full border rounded-lg px-4 py-3" />
        </div>
        <div>
          <label className="block text-gray-600 mb-2">Password</label>
          <input type="password" className="w-full border rounded-lg px-4 py-3" />
        </div>
        <button className="w-full bg-red-500 text-white rounded-lg py-3 font-medium">LOG IN</button>
      </div>

      <p className="text-center mb-8">
        <a href="#" className="text-gray-600 underline">
          Signup instead?
        </a>
      </p>

      <div className="text-center text-sm text-gray-600 space-y-2">
        <p>
          Having issues?{" "}
          <a href="#" className="underline">
            Email us
          </a>
        </p>
        <p>
          <a href="#" className="underline">
            Terms of service
          </a>
          {" · "}
          <a href="#" className="underline">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;